/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    common: {
      init: function () {
        // JavaScript to be fired on all pages
        var nav = responsiveNav(".mobile-nav", {
          label: "",
        });

        // Cookie Consent
        window.addEventListener("load", function () {
          window.cookieconsent.initialise({
            palette: {
              popup: {
                background: "#223151",
                text: "#ffffff",
              },
              button: {
                background: "#4e99de",
                text: "#ffffff",
              },
              button: {
                background: "#4e99de",
                text: "#ffffff",
              },
            },
          });
        });
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        // Select all links with hashes
        $('a[href*="#"]')
          // Remove links that don't actually link to anything
          .not('[href="#"]')
          .not('[href="#0"]')
          .click(function (event) {
            // On-page links
            if (
              location.pathname.replace(/^\//, "") ===
                this.pathname.replace(/^\//, "") &&
              location.hostname === this.hostname
            ) {
              // Figure out element to scroll to
              var target = $(this.hash);
              target = target.length
                ? target
                : $("[name=" + this.hash.slice(1) + "]");
              // Does a scroll target exist?
              if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                $("html, body").animate(
                  {
                    scrollTop: target.offset().top,
                  },
                  1000,
                  function () {
                    // Callback after animation
                    // Must change focus!
                    var $target = $(target);
                    $target.focus();
                    if ($target.is(":focus")) {
                      // Checking if the target was focused
                      return false;
                    } else {
                      $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                      $target.focus(); // Set focus again
                    }
                  }
                );
              }
            }
          });
      },
    },
    // template-road-closures.php
    page_template_template_road_closures: {
      init: function () {
        // JavaScript to be fired on the home page
        var settings = {
          viewportWidth: "100%",
          viewportHeight: "100%",
          fitToViewportShortSide: true,
          contentSizeOver100: false,
          startScale: 0,
          startX: 0,
          startY: 0,
          animTime: 500,
          draggInertia: 10,
          imgDir:
            document.location.origin +
            "/app/themes/porthcawl/dist/images/rc-maps/",
          mainImgWidth: 2480,
          mainImgHeight: 1753,
          intNavEnable: true,
          intNavPos: "B",
          intNavAutoHide: false,
          intNavMoveDownBtt: true,
          intNavMoveUpBtt: true,
          intNavMoveRightBtt: true,
          intNavMoveLeftBtt: true,
          intNavZoomBtt: true,
          intNavUnzoomBtt: true,
          intNavFitToViewportBtt: true,
          intNavFullSizeBtt: true,
          intNavBttSizeRation: 2,
          mapEnable: true,
          mapPos: "BL",
          popupShowAction: "click",
          testMode: false,
        };
        $("#rcMap").lhpGigaImgViewer(settings);
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      },
    },
    // Home page
    home: {
      init: function () {
        // JavaScript to be fired on the home page
        $("#homeSlider").slick({
          dots: false,
          infinite: true,
          speed: 3000,
          autoplay: true,
          fade: true,
          slidesToShow: 1,
          arrows: false,
          centerMode: true,
        });
        /* Homepage Countdown Clock
          Starts Jan as 0
          Therefore August = 7 not 8
         */
        var marathonDateSelector = document.getElementById("countdown");
        var marathonDateAttr = $(marathonDateSelector).data("date");
        marathonLaunch = new Date(marathonDateAttr);
        $("#countdown").countdown({
          until: marathonLaunch,
          padZeroes: true,
        });
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
        //sliderHeight
        var slideRowHeight = $(".slide-row").delay(800).outerHeight(true);
        $(".slide").css("height", slideRowHeight + "px");
        $(window).resize(function () {
          var slideRowHeight = $(".slide-row").delay(800).outerHeight(true);
          $(".slide").css("height", slideRowHeight + "px");
          console.log(slideRowHeight);
        });
        var settings = {
          viewportWidth: "100%",
          viewportHeight: "100%",
          fitToViewportShortSide: true,
          contentSizeOver100: true,
          startScale: 0,
          startX: 0,
          startY: 0,
          animTime: 300,
          draggInertia: 10,
          imgDir:
            document.location.origin +
            "/app/themes/porthcawl/dist/images/route/",
          mainImgWidth: 3984,
          mainImgHeight: 2196,
          intNavEnable: true,
          intNavPos: "B",
          intNavAutoHide: false,
          intNavMoveDownBtt: true,
          intNavMoveUpBtt: true,
          intNavMoveRightBtt: true,
          intNavMoveLeftBtt: true,
          intNavZoomBtt: true,
          intNavUnzoomBtt: true,
          intNavFitToViewportBtt: true,
          intNavFullSizeBtt: true,
          intNavBttSizeRation: 2,
          mapEnable: true,
          mapPos: "BL",
          popupShowAction: "click",
          testMode: false,
        };
        $("#routemap").lhpGigaImgViewer(settings);
      },
    },

    // About us page, note the change from about-us to about_us.
    about_us: {
      init: function () {
        // JavaScript to be fired on the about us page
      },
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(
        document.body.className.replace(/-/g, "_").split(/\s+/),
        function (i, classnm) {
          UTIL.fire(classnm);
          UTIL.fire(classnm, "finalize");
        }
      );

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    },
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
